export type QueryParams = {
  userId?: string;
};

export abstract class FetchMissedCromsCountQuery {
  abstract fetchCount(params?: QueryParams): Promise<number>;
}
